import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sections"
export default class extends Controller {
  connect() {
    if (!document.querySelector('[data-namespace*="sections/"]')) return

    this.setupAddBlockButtons()
  }

  setupAddBlockButtons() {
    document.querySelectorAll(".add-block").forEach(button => {
      button.addEventListener("click", (e) => {
        e.preventDefault()

        button.style.display = "none"
        document.querySelectorAll(".new-block").forEach(block => {
          block.classList.remove("d-none")
        })
      })
    })
  }
}
